/**
 * I was forced to create this service in order to mock window.location.href in tests
 * */
export const LocationService = {
    getCurrentUrl: (): string => window.location.origin,
};
